"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.1
//   protoc               v3.12.4
// source: mryum/payment/v1/payment_processor.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentProcessorToNumber = exports.paymentProcessorToJSON = exports.paymentProcessorFromJSON = exports.PaymentProcessor = exports.protobufPackage = void 0;
/* eslint-disable */
exports.protobufPackage = "mryum.payment.v1";
exports.PaymentProcessor = {
    PAYMENT_PROCESSOR_UNSPECIFIED: "PAYMENT_PROCESSOR_UNSPECIFIED",
    STRIPE: "STRIPE",
    /** POS - A payment may be placed through a POS and recorded in our system */
    POS: "POS",
    /** ZERO_AMOUNT - Different to Unpaid, ZERO_AMOUNT is used when a discount or loyalty reward has reduced the price to $0 */
    ZERO_AMOUNT: "ZERO_AMOUNT",
    /**
     * POST_PAID - Post paid orders are where payment is collected after the order is created e.g. cash/unpaid/charge to room.
     * Very similar flow to ZERO_AMOUNT, except additional metadata is passed through to create the order.
     */
    POST_PAID: "POST_PAID",
    CASH: "CASH",
    /** EONX - The processor used by "The Pass" app. Used to record a payment attempt against EONX's payment gateway. */
    EONX: "EONX",
    /** PAYSTACK - The processor used in South Africa (and can be used throughout Africa) */
    PAYSTACK: "PAYSTACK",
};
function paymentProcessorFromJSON(object) {
    switch (object) {
        case 0:
        case "PAYMENT_PROCESSOR_UNSPECIFIED":
            return exports.PaymentProcessor.PAYMENT_PROCESSOR_UNSPECIFIED;
        case 1:
        case "STRIPE":
            return exports.PaymentProcessor.STRIPE;
        case 2:
        case "POS":
            return exports.PaymentProcessor.POS;
        case 3:
        case "ZERO_AMOUNT":
            return exports.PaymentProcessor.ZERO_AMOUNT;
        case 4:
        case "POST_PAID":
            return exports.PaymentProcessor.POST_PAID;
        case 5:
        case "CASH":
            return exports.PaymentProcessor.CASH;
        case 6:
        case "EONX":
            return exports.PaymentProcessor.EONX;
        case 7:
        case "PAYSTACK":
            return exports.PaymentProcessor.PAYSTACK;
        default:
            return exports.PaymentProcessor.PAYMENT_PROCESSOR_UNSPECIFIED;
    }
}
exports.paymentProcessorFromJSON = paymentProcessorFromJSON;
function paymentProcessorToJSON(object) {
    switch (object) {
        case exports.PaymentProcessor.PAYMENT_PROCESSOR_UNSPECIFIED:
            return "PAYMENT_PROCESSOR_UNSPECIFIED";
        case exports.PaymentProcessor.STRIPE:
            return "STRIPE";
        case exports.PaymentProcessor.POS:
            return "POS";
        case exports.PaymentProcessor.ZERO_AMOUNT:
            return "ZERO_AMOUNT";
        case exports.PaymentProcessor.POST_PAID:
            return "POST_PAID";
        case exports.PaymentProcessor.CASH:
            return "CASH";
        case exports.PaymentProcessor.EONX:
            return "EONX";
        case exports.PaymentProcessor.PAYSTACK:
            return "PAYSTACK";
        default:
            return "PAYMENT_PROCESSOR_UNSPECIFIED";
    }
}
exports.paymentProcessorToJSON = paymentProcessorToJSON;
function paymentProcessorToNumber(object) {
    switch (object) {
        case exports.PaymentProcessor.PAYMENT_PROCESSOR_UNSPECIFIED:
            return 0;
        case exports.PaymentProcessor.STRIPE:
            return 1;
        case exports.PaymentProcessor.POS:
            return 2;
        case exports.PaymentProcessor.ZERO_AMOUNT:
            return 3;
        case exports.PaymentProcessor.POST_PAID:
            return 4;
        case exports.PaymentProcessor.CASH:
            return 5;
        case exports.PaymentProcessor.EONX:
            return 6;
        case exports.PaymentProcessor.PAYSTACK:
            return 7;
        default:
            return 0;
    }
}
exports.paymentProcessorToNumber = paymentProcessorToNumber;
